import { render, staticRenderFns } from "./GuppyFloatingChatList.vue?vue&type=template&id=50cab118&scoped=true&"
import script from "./GuppyFloatingChatList.vue?vue&type=script&lang=js&"
export * from "./GuppyFloatingChatList.vue?vue&type=script&lang=js&"
import style0 from "./GuppyFloatingChatList.vue?vue&type=style&index=0&id=50cab118&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50cab118",
  null
  
)

export default component.exports